import { mdiCog } from "@mdi/js";

const Nav = [
  {
    title: "Admin",
    icon: mdiCog,
    children: [
      {
        title: "Univers",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Liste des univers",
            to: "admin-list-group-site",
            resource: "admin",
            action: "manage",
          },
          {
            title: "Créer/éditer un univers",
            to: "admin-edit-group-site",
            resource: "admin",
            action: "manage",
          },
        ],
      },
      {
        title: "Rapports",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Liste des rapports",
            to: "admin-list-email-report",
            resource: "admin",
            action: "manage",
          },
          {
            title: "Créer un rapport",
            to: "admin-create-email-report",
            resource: "admin",
            action: "manage",
          },
        ],
      },
      {
        title: "Exports",
        to: "admin-exports",
        resource: "admin",
        action: "manage",
      },
      {
        title: "Alertes",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Liste des rapports d'alerte",
            to: "admin-list-alert-report",
            resource: "admin",
            action: "manage",
          },
          {
            title: "Créer un rapport d'alerte",
            to: "admin-create-alert-report",
            resource: "admin",
            action: "manage",
          },
        ],
      },
      {
        title: "Sites",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Liste",
            to: "admin-list-site",
            resource: "admin",
            action: "manage",
          },
        ],
      },
      {
        title: "Marmiton",
        resource: "all",
        action: "manage",
        children: [
          {
            title: "Groupes d'ingrédients",
            to: "admin-marmiton-list-ingredient-groups",
            resource: "all",
            action: "manage",
          },
          {
            title: "Créer un groupe d'ingrédients",
            to: "admin-marmiton-create-ingredient-group",
            resource: "all",
            action: "manage",
          },
        ],
      },
      {
        title: "Notifications",
        to: "notifications",
        resource: "all",
        action: "manage",
      },
      {
        title: "Data Availability",
        to: "admin-data-availability",
        resource: "admin",
        action: "manage",
      },
      {
        title: "AI Factory",
        resource: ["admin", "ai_factory"],
        action: "manage",
        children: [
          {
            title: "Post Create",
            to: "admin-post-create",
            resource: ["admin", "ai_factory"],
            action: "manage",
          },
          {
            title: "Prompts (par Process)",
            to: "admin-prompt-config",
            resource: ["admin", "ai_factory"],
            action: "manage",
          },
          {
            title: "Prompts (Tout AIF)",
            to: "admin-prompt-config-new",
            resource: ["admin", "ai_factory"],
            action: "manage",
          },
          {
            title: "Maillage Interne",
            to: "admin-aif-internal-linking",
            resource: ["admin", "ai_factory"],
            action: "manage",
          },
          {
            title: "Queue config",
            to: "admin-aif-queue-config",
            resource: "admin",
            action: "manage",
          },
          {
            title: "Transcription vidéo",
            to: "admin-aif-transcription-config",
            resource: "all",
            action: "manage",
          },
        ],
      },
      {
        title: "Models IA",
        to: "admin-llpr-models",
        resource: "admin",
        action: "manage",
      },
      {
        title: "Contextes de Prompts",
        to: "admin-llpr-contexts",
        resource: "admin",
        action: "manage",
      },
      {
        title: "Prompts (Toutes familles)",
        to: "admin-prompt-config-all",
        resource: "admin",
        action: "manage",
      },
      {
        title: "Système",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Backfill Audience / adn_post",
            to: "admin-audience-backfill",
            resource: "all",
            action: "manage",
          },
          {
            title: "Workflows",
            to: "admin-aiflow-start-dag",
            resource: "all",
            action: "manage",
          },
          {
            title: "Alertes Airflow",
            to: "admin-airflow-alerts",
            resource: "all",
            action: "manage",
          },
          {
            title: "RAM snapshots",
            to: "admin-system-ram-snapshots",
            resource: "admin",
            action: "manage",
          },
        ],
      },
    ],
  },
];

export default Nav;
